import { ShieldAlert } from 'lucide-react'
import { ButtonLink, EmptyState } from '@/components/ui'
import { ROLE_LABELS, type Role } from '@shared/model'

export function NoAccess({ required }: { required: Role }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg p-4">
      <EmptyState
        icon={<ShieldAlert size={44} aria-hidden />}
        title="Du saknar behörighet"
        description={`Den här sidan är till för rollen ${ROLE_LABELS[required].toLowerCase()}. Tror du att det blivit fel? Hör av dig till kansliet så ser vi över ditt konto.`}
        action={
          <ButtonLink to="/" variant="quiet" className="mt-1">
            Tillbaka till häftet
          </ButtonLink>
        }
      />
    </div>
  )
}
